export const TYPES = [
  { name: 'API GraphQL', id: 'graphql' },
  { name: 'API Rest', id: 'rest' },
  { name: 'Página Publica', id: 'page' }
]
